import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './plugins/element.js'
//import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios';
//import ElementUI from 'element-ui';

//Vue.use(ElementUI)
//Vue.use('element-ui')
/* axios.interceptors.response.use(
  response => {
    let res = response.data;
    if(res.loginState === false){
      router.replace({
        path: '/login',
        //query: {redirect: router.currentRoute.fullPath}
      })
    }
    return response;
  }); */
 
Vue.prototype.$http = axios;
Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  if(to.meta.auth){
    if(window.sessionStorage.getItem('userName')){
      next();
    }else{
      next({
        path: '/login',
        //query: {redirect: to.fullPath}  // 将跳转的路由path作为参数，登录成功后跳转到该路由
      });
    }
  }else{
    next();
  }
})
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
